(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["murf-film"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('murf-film-player')) {
 class MurfFilmPlayer extends HTMLElement {
  connectedCallback() {
   if (this.ready) return;
   this.ready = true;
   this.pausedByUser = false;
   this.muted = true;
   this.inView = false;
   this.playButton = this.querySelector('[data-film-play]');
   this.soundButton = this.querySelector('[data-film-sound]');
   this.reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
   if (this.reduceMotion) this.playButton.textContent = this.dataset.playLabel;
   this.playButton.addEventListener('click', () => {
    this.pausedByUser = !this.pausedByUser;
    if (!this.frame) { this.pausedByUser = false; this.mount(true); }
    this.command(this.pausedByUser ? 'pauseVideo' : 'playVideo');
    this.playButton.textContent = this.pausedByUser ? this.dataset.playLabel : this.dataset.pauseLabel;
   });
   this.soundButton.addEventListener('click', () => {
    if (!this.frame) this.mount(true);
    this.muted = !this.muted;
    this.command(this.muted ? 'mute' : 'unMute');
    this.soundButton.textContent = this.muted ? this.dataset.soundLabel : this.dataset.muteLabel;
   });
   this.observer = new IntersectionObserver(entries => {
    this.inView = entries[0].isIntersecting;
    if (this.inView && !this.reduceMotion && !this.pausedByUser) {
     if (!this.frame) this.mount(true);
     else this.command('playVideo');
    } else if (this.frame) this.command('pauseVideo');
   }, { threshold: 0.45 });
   this.observer.observe(this);
  }
  mount(autoplay) {
   this.frame = document.createElement('iframe');
   this.frame.title = this.dataset.title;
   this.frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
   this.frame.allowFullscreen = true;
   const url = new URL('https://www.youtube-nocookie.com/embed/' + this.dataset.videoId);
   const params = { autoplay: autoplay ? '1' : '0', mute: '1', controls: '0', loop: '1', playlist: this.dataset.videoId, playsinline: '1', rel: '0', iv_load_policy: '3', enablejsapi: '1', origin: location.origin };
   Object.entries(params).forEach(([key,value]) => url.searchParams.set(key,value));
   this.frame.src = url.href;
   this.frame.addEventListener('load', () => {
    this.frame.classList.add('is-loaded');
    if (!this.inView || this.pausedByUser) this.command('pauseVideo');
   });
   this.querySelector('.murf-film__mount').append(this.frame);
  }
  command(func) {
   this.frame?.contentWindow?.postMessage(JSON.stringify({event:'command',func,args:[]}), 'https://www.youtube-nocookie.com');
  }
  disconnectedCallback() { this.observer?.disconnect(); this.command('pauseVideo'); }
 }
 customElements.define('murf-film-player', MurfFilmPlayer);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ngm-murf-launch"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('murf-range-picker')) customElements.define('murf-range-picker', class extends HTMLElement {
 connectedCallback() {
  if (this.dataset.ready) return;
  this.dataset.ready = 'true';
  const controls = this.querySelector('.murf-world__filters');
  if (!controls) return;
  controls.hidden = false;
  controls.addEventListener('click', event => {
   const button = event.target.closest('[data-murf-filter]');
   if (!button) return;
   controls.querySelectorAll('button').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
   this.querySelectorAll('[data-murf-category]').forEach(card => {card.hidden = button.dataset.murfFilter !== 'all' && card.dataset.murfCategory !== button.dataset.murfFilter;});
  });
 }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["often-product-story"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('often-video-player')) {
  customElements.define('often-video-player', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized) return;
      const button = this.querySelector('button');
      if (!button) return;
      this.dataset.initialized = 'true';
      button.addEventListener('click', () => {
        const id = this.dataset.videoId;
        const provider = this.dataset.provider;
        if (!id || !['youtube', 'vimeo'].includes(provider)) return;
        const frame = document.createElement('iframe');
        frame.src = provider === 'youtube' ? `https://www.youtube-nocookie.com/embed/${encodeURIComponent(id)}?rel=0` : `https://player.vimeo.com/video/${encodeURIComponent(id)}?dnt=1`;
        frame.title = this.dataset.title;
        frame.loading = 'lazy';
        frame.allow = 'fullscreen; picture-in-picture';
        frame.allowFullscreen = true;
        frame.referrerPolicy = 'strict-origin-when-cross-origin';
        this.replaceChildren(frame);
        frame.focus();
      }, { once: true });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["often-rooftop-story"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('often-rooftop-video')) {
  customElements.define('often-rooftop-video', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized) return;
      const button = this.querySelector('button');
      if (!button) return;
      this.dataset.initialized = 'true';
      const poster = this.querySelector('img[data-fallback]');
      if (poster) {
        const useFallback = () => {
          const fallback = poster.dataset.fallback;
          if (!fallback) return;
          delete poster.dataset.fallback;
          poster.src = fallback;
        };
        poster.addEventListener('error', useFallback, { once: true });
        if (poster.complete && poster.naturalWidth === 0) useFallback();
      }
      button.addEventListener('click', () => {
        const id = this.dataset.videoId;
        const provider = this.dataset.provider;
        if (!id || !['youtube', 'vimeo'].includes(provider)) return;
        const frame = document.createElement('iframe');
        frame.src = provider === 'youtube' ? `https://www.youtube-nocookie.com/embed/${encodeURIComponent(id)}?rel=0&autoplay=1` : `https://player.vimeo.com/video/${encodeURIComponent(id)}?dnt=1&autoplay=1`;
        frame.title = this.dataset.title;
        frame.loading = 'lazy';
        frame.allow = 'autoplay; fullscreen; picture-in-picture';
        frame.allowFullscreen = true;
        frame.referrerPolicy = 'strict-origin-when-cross-origin';
        this.replaceChildren(frame);
        frame.focus();
      }, { once: true });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yerka-product-story"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('yerka-size-finder')) {
    customElements.define('yerka-size-finder', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        const form = this.querySelector('form');
        const data = this.querySelector('script[type="application/json"]');
        if (!form || !data) return;
        let config;
        try { config = JSON.parse(data.textContent); } catch (error) { return; }
        if (!Array.isArray(config.sizes) || !config.sizes.length) return;
        this.initialized = true;
        form.hidden = false;
        const height = form.elements.height;
        const inseam = form.elements.inseam;
        const result = this.querySelector('[role="status"]');
        const clearError = () => { inseam.setCustomValidity(''); result.replaceChildren(); };
        height.addEventListener('input', clearError);
        inseam.addEventListener('input', clearError);
        form.addEventListener('submit', (event) => {
          event.preventDefault();
          inseam.setCustomValidity('');
          if (!form.reportValidity()) return;
          const riderHeight = Number(height.value);
          const hasInseam = inseam.value !== '';
          const riderInseam = hasInseam ? Number(inseam.value) : null;
          result.replaceChildren();
          if (hasInseam && riderInseam >= riderHeight) {
            inseam.setCustomValidity(config.invalidInseam);
            result.textContent = config.invalidInseam;
            inseam.reportValidity();
            return;
          }
          const matches = config.sizes.filter(size => riderHeight >= Number(size.minHeight) && riderHeight <= Number(size.maxHeight) && (!hasInseam || riderInseam >= Number(size.minInseam)));
          if (!matches.length) {
            result.textContent = config.none;
          } else {
            const heading = document.createElement('p');
            heading.textContent = config.matches;
            result.append(heading);
            const list = document.createElement('ul');
            matches.forEach(size => {
              const item = document.createElement('li');
              item.textContent = `${size.label} — ${config.minimum}: ${size.minInseam} cm`;
              list.append(item);
            });
            result.append(list);
            if (!hasInseam) {
              const guidance = document.createElement('p');
              guidance.textContent = config.missingInseam;
              result.append(guidance);
            }
          }
          result.focus({ preventScroll: true });
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
